import { FC, ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';
import { getByDocCreator } from '../helpers/getByDocCreator';
import {
    useItemTranslations,
    INTERFACE_STATE,
} from '../PdpSharedOriginalLanguageProvider/PdpSharedOriginalLanguageProvider';

import { PdpRespTitle_item$key } from './__generated__/PdpRespTitle_item.graphql';

import styles from './PdpRespTitle.scss';

type Props = {
    item: PdpRespTitle_item$key;
};

export const PdpRespTitle: FC<Props> = ({ item: itemRef }) => {
    const item = useFragment(
        graphql`
            fragment PdpRespTitle_item on Item {
                title
                isArt
                creators {
                    attribution
                    creator {
                        name
                        displayName
                    }
                }
                classification {
                    creationDate
                }
            }
        `,
        itemRef
    );

    const { isArt, title, creators, classification } = item || {};

    let artCreator = null;
    let artCreationDate = null;
    const [state] = useItemTranslations();
    let itemTitle: string | ReactNode =
        state?.interfaceState === INTERFACE_STATE.SHOW_ORIGINAL
            ? state?.data?.viewer?.item?.title
            : title;

    if (isArt) {
        itemTitle = (
            <span className={styles.artTitle} data-tn="pdp-item-title">
                {itemTitle}
            </span>
        );

        const creationDate = classification?.creationDate;
        if (creationDate) {
            artCreationDate = (
                <p className={styles.artCreationDate} data-tn="pdp-item-creation-date">
                    {creationDate}
                </p>
            );
        }

        artCreator = getByDocCreator(creators);
    }

    return (
        <h1 className={styles.wrapper} data-tn="pdp-resp-title">
            {artCreator}
            <div data-tn="pdp-main-title">
                {itemTitle}
                {artCreationDate}
            </div>
        </h1>
    );
};
